import type { MouseEvent } from 'react';
import application from 'services/application';
import navigation, { link } from 'services/navigation';
import featureToggle from 'services/feature-toggle';
import { Flags } from 'services/feature-toggle/flags';

const onTriggerPreventDefault = <T>(callback: () => void): ((event: MouseEvent<T>) => void) => {
  return (event: MouseEvent<T>): void => {
    event.preventDefault();

    callback();
  };
};

// @TODO: Remove this function when simplified registration is released for Oranum MSC-32374
const getSignupLink = (): string => {
  return application.LiveJasmin && !featureToggle.enabled(Flags.enableLegacySignup)
    ? link.simplifiedSignup()
    : link.signup();
};

// @TODO: Remove this function when simplified registration is released for Oranum MSC-32374
const navigateToSignup = (): void => {
  if (application.LiveJasmin && !featureToggle.enabled(Flags.enableLegacySignup)) {
    navigation.simplifiedSignup();
  } else {
    navigation.signup();
  }
};

export { onTriggerPreventDefault, getSignupLink, navigateToSignup };
